import React, { useState } from 'react';
import { PropTypes, func, oneOf, number, node, string } from 'prop-types';
import PactometroCheck from './checks';
import PactometroBarrasSimple from './barrasSimple';
import './index.scss';
import { SCContainerPactometroSimple } from './style';

const PactometroCheckSimple = ({
  seatData,
  totalSeat,
  onChange,
  checksCols,
  cols,
  legend,
  legend2,
  type,
  pactometroType
}) => {
  const [selectedsId, setSelectedsId] = useState([]);
  const filterData = seatData.filter(current => current.seats >= 1);
  const { totalVotes } = filterData.reduce(
    (tot, current) => {
      tot.totalVotes += current.votes;
      tot.totalSeat += current.seats;
      return tot;
    },
    { totalVotes: 0, totalSeat: 0 }
  );
  return (
    <SCContainerPactometroSimple className="containerPactometro" cols={cols}>
      <div className="content-pactos-barras content-pactos-barrasSimple">
        <PactometroBarrasSimple
          data={filterData}
          selecteds={selectedsId}
          totalSeat={totalSeat}
          totalVotes={totalVotes}
          type={type}
        />
      </div>
      <div className="content-pactos content-pactosSimple">
        <div className="pactosScrollContent">
          <div className="pactosScroll">
            <PactometroCheck
              data={filterData}
              selecteds={selectedsId}
              onChange={val => {
                setSelectedsId(val);
                onChange && onChange(val);
              }}
              type={type}
              pactometroType={pactometroType}
            />
          </div>
        </div>
        {legend && <p className="legend content-pactos_legend">{legend}</p>}
        {legend2 && <p className="legend content-pactos_legend">{legend2}</p>}
      </div>
    </SCContainerPactometroSimple>
  );
};
PactometroCheckSimple.defaultProps = {
  cols: 1
};
PactometroCheckSimple.propTypes = {
  seatData: PropTypes.arrayOf(
    PropTypes.shape({
      partyAcronym: PropTypes.string.isRequired,
      seats: PropTypes.number,
      votesPercent: PropTypes.number.isRequired,
      votes: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired
    })
  ).isRequired,
  onChange: func,
  checksCols: number,
  cols: oneOf([1, 2]),
  legend: node,
  pactometroType: string
};

export default PactometroCheckSimple;
